import React, { useContext } from 'react';
import { SelectedProviderType } from './types';
import { InsuranceCompany } from '@uplift/types';

export type SelectedProviderContextProps = {
  selectedProvider: SelectedProviderType;
  matchedInsuranceCompany: Pick<InsuranceCompany, 'shortName'> | undefined | null;
};

export const SelectedProviderContext = React.createContext<SelectedProviderContextProps>({
  selectedProvider: {} as SelectedProviderType,
  matchedInsuranceCompany: undefined,
});

export const useSelectedProviderContext = () => useContext(SelectedProviderContext);
